<div class="dx-card padding-content">
    <div class="toolbar">
        <dx-button
            icon="back"
            stylingMode="text"
            hint="กลับไปหน้า Reordering"
            (onClick)="backToReordering()"
        ></dx-button>
        <span class="page-title">ข้อมูล 1688</span>
        <dx-text-box
            mode="search"
            placeholder="ค้นหา SKU ชื่อสินค้า หรือร้าน"
            valueChangeEvent="input"
            [width]="280"
            [(value)]="searchText"
        ></dx-text-box>
        <dx-button-group
            [items]="filterItems"
            keyExpr="key"
            selectionMode="single"
            stylingMode="outlined"
            [selectedItemKeys]="selectedFilterKeys"
            (onItemClick)="onFilterPicked($event)"
        ></dx-button-group>
        <dx-check-box
            text="ซ่อนที่พักสั่งซื้อและเลิกขาย"
            [(value)]="hideIdle"
            (onValueChanged)="applyFilter()"
        ></dx-check-box>
        <div class="toolbar-spacer"></div>
        <dx-button
            stylingMode="contained"
            icon="home"
            text="ชื่อร้าน ({{ index.shops.length }})"
            hint="ตั้งชื่อร้านภาษาอังกฤษ"
            (onClick)="openShops()"
        ></dx-button>
        <dx-button
            stylingMode="contained"
            icon="refresh"
            hint="Reload data"
            [disabled]="loading"
            (onClick)="load()"
        ></dx-button>
    </div>

    <dx-data-grid
        #dataGrid
        id="supplier1688Grid"
        height="100%"
        keyExpr="_id"
        [dataSource]="visibleRows"
        [showBorders]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        [allowColumnResizing]="true"
    >
        <dxo-search-panel [visible]="false" [text]="searchText"></dxo-search-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="50"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <dxi-column dataField="sku" caption="SKU" [width]="100"></dxi-column>
        <dxi-column
            dataField="title"
            caption="ชื่อสินค้า"
            [minWidth]="220"
            cellTemplate="titleTemplate"
        ></dxi-column>
        <dxi-column
            dataField="class"
            caption="Class"
            [width]="70"
            alignment="center"
        ></dxi-column>
        <dxi-column
            dataField="total_sale"
            caption="ยอดขาย 1 ปี"
            [width]="100"
            dataType="number"
            sortOrder="desc"
            cellTemplate="moneyTemplate"
        ></dxi-column>
        <dxi-column
            dataField="remain"
            caption="คงเหลือ"
            [width]="75"
            dataType="number"
        ></dxi-column>
        <dxi-column
            dataField="statusText"
            caption="สถานะ"
            [width]="130"
        ></dxi-column>
        <dxi-column
            dataField="supplier.label"
            caption="1688"
            [width]="300"
            cellTemplate="supplierTemplate"
        ></dxi-column>
        <dxi-column
            dataField="supplier.shopName"
            caption="ร้าน"
            [width]="140"
        ></dxi-column>
        <dxi-column
            dataField="supplier.costCny"
            caption="¥ ล่าสุด"
            [width]="80"
            dataType="number"
            cellTemplate="moneyTemplate"
        ></dxi-column>
        <dxi-column
            dataField="supplier.lastOrderDate"
            caption="ซื้อล่าสุด"
            [width]="100"
        ></dxi-column>
        <dxi-column dataField="note" caption="หมายเหตุ" [width]="240"></dxi-column>
        <dxi-column
            caption=""
            [width]="130"
            [allowFiltering]="false"
            [allowSorting]="false"
            alignment="center"
            cellTemplate="actionsTemplate"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'titleTemplate'">
            <a
                [href]="adminProductUrl(cellData.data._id)"
                target="_blank"
                [title]="cellData.value"
                class="grid-link-ellipsis"
            >
                {{ cellData.value }}
            </a>
        </div>
        <div *dxTemplate="let cellData of 'moneyTemplate'">
            {{ cellData.value | formatNumber : 2 }}
        </div>
        <div *dxTemplate="let cellData of 'supplierTemplate'">
            @if (cellData.data.supplier; as supplier) {
            <app-supplier-1688-links
                [supplier]="supplier"
            ></app-supplier-1688-links>
            }
        </div>
        <div *dxTemplate="let cellData of 'actionsTemplate'" class="row-actions">
            <dx-button
                class="row-action"
                stylingMode="text"
                text="แก้ไข"
                (onClick)="edit(cellData.data)"
            ></dx-button>
            @if (cellData.data.status === 'check') {
            <dx-button
                class="row-action"
                stylingMode="text"
                text="ถูกต้อง"
                hint="ข้อมูลที่ match ถูกต้องแล้ว"
                (onClick)="confirm(cellData.data)"
            ></dx-button>
            }
        </div>
    </dx-data-grid>
</div>

<app-supplier-1688-editor
    #editor
    (saved)="onOverridesSaved($event)"
></app-supplier-1688-editor>

<dx-popup
    [(visible)]="shopsPopupVisible"
    [showTitle]="true"
    title="ชื่อร้าน"
    [dragEnabled]="true"
    [hideOnOutsideClick]="true"
    [width]="860"
    maxWidth="96vw"
    height="80vh"
>
    <div class="shops-hint">
        คลิกช่องชื่อภาษาอังกฤษเพื่อแก้ ถ้าเว้นว่างจะกลับไปใช้ชื่อจากลิงก์ร้าน
    </div>
    <dx-data-grid
        keyExpr="url"
        height="calc(100% - 28px)"
        [dataSource]="index.shops"
        [showBorders]="true"
        [showRowLines]="true"
        [hoverStateEnabled]="true"
        (onRowUpdating)="onShopUpdating($event)"
    >
        <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxi-column dataField="name" caption="ชื่อภาษาอังกฤษ"></dxi-column>
        <dxi-column
            dataField="companyName"
            caption="ชื่อบริษัทบน 1688"
            [allowEditing]="false"
        ></dxi-column>
        <dxi-column
            dataField="url"
            caption="ลิงก์ร้าน"
            [allowEditing]="false"
            cellTemplate="shopLinkTemplate"
        ></dxi-column>
        <dxi-column
            dataField="products"
            caption="สินค้า"
            [width]="80"
            dataType="number"
            [allowEditing]="false"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'shopLinkTemplate'">
            <a
                [href]="cellData.value"
                target="_blank"
                rel="noopener noreferrer"
                class="grid-link-ellipsis"
                >{{ cellData.value }}</a
            >
        </div>
    </dx-data-grid>
</dx-popup>
